import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-operator-icon',
    templateUrl: './operator-icon.component.html',
})
export class OperatorIconComponent {
    public readonly path = input<string | null>();
    public readonly size = input<string | number | null>(1.5);
}
